import { extendTheme } from "@chakra-ui/react";
import { mainTheme } from "./colors/mainTheme";

export const theme = extendTheme({
  colors: mainTheme,
  styles: {
    global: () => ({
      body: {
        bg: mainTheme.talesBackground,
      },
    }),
  },
  components: {
    Heading: {
      sizes: {
        lg: {
          fontFamily: "heading",
          color: mainTheme.talesWhite,
          letterSpacing: "wider",
        },
        md: {
          fontFamily: "heading",
          color: mainTheme.talesBlack["500"],
          letterSpacing: "wide",
        },
        base: {
          fontFamily: "subtitle",
          fontWeight: "bold",
          color: mainTheme.talesBlack["500"],
        },
      },
      variants: {
        fontSize: {
          lg: {
            base: "xl",
            sm: "2xl",
            md: "3xl",
            lg: "4xl",
          },
          md: {
            base: "xl",
            sm: "2xl",
            md: "3xl",
          },
          sm: {
            base: "md",
            md: "lg",
          },
        },
      },
    },
    Button: {
      variants: {
        talesButton: {
          background: mainTheme.talesLightYellow["500"],
          textTransform: "uppercase",
          color: mainTheme.talesSecondary["500"],
          fontFamily: "subtitle",
          _hover: {
            color: mainTheme.talesSecondary["700"],
            background: mainTheme.talesYellow["500"],
          },
        },
      },
      defaultProps: {
        variant: "talesButton",
      },
    },
    Link: {
      variants: {
        navbarCurrent: {
          fontFamily: "subtitle",
          fontWeight: "bold",
          color: mainTheme.talesWhite,
          textDecoration: "underline",
          _hover: {
            color: mainTheme.talesWhite,
            cursor: "default",
          },
        },
        navbar: {
          fontFamily: "subtitle",
          fontWeight: "bold",
          color: mainTheme.talesSecondary["500"],
          _hover: {
            color: mainTheme.talesWhite,
          },
        },
        talesLink: {
          fontFamily: "subtitle",
          color: mainTheme.talesSecondary["500"],
        },
      },
      defaultProps: {
        variant: "talesLink",
      },
    },
    Text: {
      variants: {
        footer: {
          fontFamily: "subtitle",
          color: mainTheme.talesBlack["500"],
          fontSize: "sm",
          py: "15px",
        },
        formError: {
          display: "block",
          fontFamily: "subtitle",
          color: mainTheme.talesYellow["500"],
          fontSize: "sm",
          py: "15px",
        },
      },
    },
  },
  fonts: {
    body: "'Cabin', sans-serif",
    heading: "Komika Axis, serif",
    subtitle: "'Exo 2', sans-serif",
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem",
  },
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },
  space: {
    full: "100%",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    space: "1.6rem",
  },
  breakpoints: {
    base: 320,
    sm: 672,
    md: 1056,
    lg: 1312,
    xl: 1584,
  },
});
